import React from "react"
import cx from "classnames";
import PropTypes from "prop-types";

import { MODES, TYPES } from "../../configs"

import styles from "./placeholder.scss"

const tabList = Object.keys(TYPES).slice(0, Object.keys(TYPES).length-1)
const cruiseType = ["Ocean", "river"]
const flightTypeHome = ["roundtrip", "oneway"]
const flightType = ["roundtrip", "oneway", "multicities"]

const NavigationPillButton = ({mode, type, brand, isInnerPage}) => {
    let tabs = tabList;
    if (type && (type === TYPES.CRUISES.toLowerCase())) {
        tabs = cruiseType
    } else if (type === TYPES.FLIGHTS.toLowerCase()) {
        if(mode === MODES.TABS){
            tabs = flightTypeHome
        } else {
            tabs = flightType
        }
    }

    return (
	<div className={cx(styles.navContainer, {
        [styles[brand]]: [styles.brand],
    })}>
		{tabs.map(tab => (
			<div 
                // eslint-disable-next-line react/no-array-index-key
				key={tab}
				className={cx(styles.navField, {
                    [styles.navFieldCruise]: type === TYPES.CRUISES?.toLowerCase(),
                    [styles.pagesNavFieldBg]: isInnerPage
                })} />
                    ))}   
	</div>
      )
}

NavigationPillButton.propTypes = {
    type: PropTypes.string.isRequired,
    brand: PropTypes.string.isRequired,
    
    isInnerPage: PropTypes.bool,
    mode: PropTypes.string,
}

NavigationPillButton.defaultProps = {
    mode: undefined,
    isInnerPage: false
}

export { NavigationPillButton }
export default NavigationPillButton